import React, { useState } from "react";
import ContinueButton from "../Buttons/ContinueButton";
import { getPlatform } from "@/lib/iap";
import TitleBox from "../TitleBox";
import { Card, Badge } from "@chakra-ui/react";
import { haptic } from "@/lib/haptic";

interface WelcomeScreenProps {
  onStartFromScratch: () => void;
  onFindMyLevel: () => void;
  name: string;
}

const WelcomeScreen: React.FC<WelcomeScreenProps> = ({ onStartFromScratch, onFindMyLevel, name }) => {
  const platform = getPlatform();
  const [selectedCard, setSelectedCard] = useState<string | null>(null);

  const handleClick = (cardId: string) => {
    haptic.soft();
    setSelectedCard(cardId);
  };

  const handleContinue = () => {
    if (selectedCard === "find") {
      onFindMyLevel();
    } else if (selectedCard === "scratch") {
      onStartFromScratch();
    }
  };

  return (
    <div className="appPadding py-0 flex flex-col h-full w-full overflow-hidden">
      <div className="pt-4 px-2 pb-2 w-full">
        <TitleBox
          title={`Welcome ${name}, where would you like to start?`}
          subtitle=""
        />
      </div>
      <div className="flex-grow flex flex-col items-center justify-start py-4 gap-6">
      <Card
          direction={"row"}
          justifyContent={"start"}
          alignItems={"center"}
          rounded={"2xl"}
          width={"full"}
          height={"100px"}
          p={5}
          gap={4}
          color={"black"}
          bg={"white"}
          border={
            selectedCard === "find"
              ? "2px solid var(--color-blue)"
              : "1px solid var(--color-grey-light)"
          }
          onClick={() => handleClick("find")}
          className={`items-center w-full ${selectedCard === "find" ? "press-animation" : ""}`}
          position="relative"
        >
          <Badge
            position="absolute"
            top={"-9px"}
            right="10px"
            bg="var(--color-blue)"
            color="white"
            borderRadius="full"
            textAlign={"center"}
            justifyContent={"center"}
            px={2}
            py={0}
            fontSize="var(--base-font-size-xs)"
            className="text-xs"
          >
            Recommended
          </Badge>
          <div className="text-5xl">🎥</div>
          <div className="flex flex-col gap-1">
            <div className={`font-semibold text-xl text-start`}>
              Find my level
            </div>
            <div className="text-sm text-start">
              Let Parrot recommend where you should start learning
            </div>
          </div>
        </Card>
        <Card
          direction={"row"}
          justifyContent={"start"}
          alignItems={"center"}
          rounded={"2xl"}
          width={"full"}
          height={"100px"}
          p={5}
          gap={4}
          color={"black"}
          bg={"white"}
          border={
            selectedCard === "scratch"
              ? "2px solid var(--color-blue)"
              : "1px solid var(--color-grey-light)"
          }
          onClick={() => handleClick("scratch")}
          className={`items-center w-full ${selectedCard === "scratch" ? "press-animation" : ""}`}
        >
          <div className="text-5xl">📗</div>
          <div className="flex flex-col gap-1">
            <div className={`font-semibold text-xl text-start`}>
              Start from scratch
            </div>
            <div className="text-sm text-start">
              Start with the easiest level
            </div>
          </div>
        </Card>
        
      </div>
      <div
        className={`flex justify-center items-center ${
          platform === "web" ? "bottom-padding-web" : "pb-6"
        }`}
        style={{ pointerEvents: "auto" }}
      >
        <ContinueButton onClick={handleContinue} text="Continue" disabled={!selectedCard} />
      </div>
    </div>
  );
};

export default WelcomeScreen;
